import { Button } from "@cmsgov/ds-medicare-gov";
import React, { useContext } from "react";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../../app/contexts/Analytics/types";
import { AppContext } from "../../../app/store";
import { HelpDrawerWrapper } from "../../../components";
import { useTranslate } from "../../../helpers";

export const PreventiveServicesTableCaption: React.FunctionComponent = () => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  return (
    <div className="mct-c-table__caption-col--1">
      <h4 className="mct-c-table__caption-title">
        {t("plan_terms.preventive_services")}
      </h4>
      <p className="ds-u-measure--wide">
        {t("plan_terms.preventive_services.definition_extended")}
      </p>
      <HelpDrawerWrapper
        toggleText={t("plan_terms.preventive_services.learn_more")}
        drawerTitle={t("plan_terms.preventive_services.learn_more")}
      >
        <span className="ds-u-font-weight--semibold">
          {t("plan_terms.preventive_services.pay_nothing")}
        </span>
        <ul>
          <li>{t("plan_terms.preventive_services.flu_shots")}</li>
          <li>{t("plan_terms.preventive_services.colonoscopies")}</li>
          <li>
            {t("plan_terms.preventive_services.cervical_cancer_screenings")}
          </li>
          <li>
            {t("plan_terms.preventive_services.breast_cancer_screenings")}
          </li>
        </ul>
        <span className="ds-u-font-weight--semibold">
          {t("plan_terms.preventive_services.have_to_pay")}
        </span>
        <ul>
          <li>{t("plan_terms.preventive_services.glaucoma_tests")}</li>
          <li>{t("plan_terms.preventive_services.diabetes_training")}</li>
          <li>{t("plan_terms.preventive_services.barium_enemas")}</li>
          <li>{t("plan_terms.preventive_services.ekg_screenings")}</li>
        </ul>
        <p>
          {t("plan_terms.preventive_services.costs_shown_disclaimer")}
          <br />
          <Button
            className="mct-c-button--ghost ds-u-padding--0"
            onClick={() => {
              const websiteLink = document.querySelector(
                "#plan-contact"
              ) as HTMLLinkElement;
              dispatch({
                type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
                settings: {
                  button: {
                    buttonStyle: AnalyticsButtonStyle.TRANSPARENT,
                    buttonType: AnalyticsButtonType.BUTTON,
                    text: t("plan_terms.preventive_services.contact_the_plan"),
                  },
                },
              });
              websiteLink?.focus();
            }}
          >
            {t("plan_terms.preventive_services.contact_the_plan")}
          </Button>{" "}
          {t("plan_terms.preventive_services.to_find_out_more")}
        </p>
      </HelpDrawerWrapper>
    </div>
  );
};
